export default __webpack_public_path__ + "static/media/Event_Card.3a6f3a57.svg";